import { withDefaultProps } from '@chakra-ui/react';
import { Footer } from './customComponents/footer';
import { SideNav } from './customComponents/sideNav';
import { Button } from './components/button';
import { styles } from './styles';
import { colors } from './foundations/colors';
import { sizes } from './foundations/sizes';
import { Header } from './customComponents/header';
import { FormLabel } from './components/formLabel';
import { Input } from './components/input';
import { fontFace } from './fontFace';
import { fonts } from './foundations/fonts';
import { fontSizes } from './foundations/fontSizes';
import { Breadcrumb } from './components/breadcrumb';
import { Checkbox } from './components/checkbox';
import { Container } from './components/container';
import { Select } from './components/select';

export default [
  {
    components: {
      Button,
      Container,
      FormLabel,
      Input,
      Select,
      Breadcrumb,
      Checkbox,

      // Custom components
      Footer,
      SideNav,
      Header,
    },
    fonts,
    fontSizes,
    sizes,
    colors,
    fontFace,
    styles,
    config: { cssVarPrefix: 'bc' },
  },
  withDefaultProps({
    defaultProps: {
      size: 'md',
      variant: 'outline',
    },
    components: ['Input', 'NumberInput', 'PinInput', 'Select', 'Textarea'],
  }),
];
